import { render } from "./ContentCategoriesPage.vue?vue&type=template&id=39c9c412&ts=true"
import script from "./ContentCategoriesPage.vue?vue&type=script&lang=ts"
export * from "./ContentCategoriesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Contents/Categories/ContentCategoriesPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39c9c412"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39c9c412', __exports__)) {
    api.reload('39c9c412', __exports__)
  }
  
  module.hot.accept("./ContentCategoriesPage.vue?vue&type=template&id=39c9c412&ts=true", () => {
    api.rerender('39c9c412', render)
  })

}


export default __exports__